import { render, staticRenderFns } from "./EventSponsors.vue?vue&type=template&id=c1122512&scoped=true&"
import script from "./EventSponsors.vue?vue&type=script&lang=js&"
export * from "./EventSponsors.vue?vue&type=script&lang=js&"
import style0 from "./EventSponsors.vue?vue&type=style&index=0&id=c1122512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1122512",
  null
  
)

export default component.exports